import { render } from "./ApiLogs.vue?vue&type=template&id=a1c00f80&ts=true"
import script from "./ApiLogs.vue?vue&type=script&lang=ts"
export * from "./ApiLogs.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__